export default {
  text: 'When ordering online, we kindly ask you to pay online. Payment can be made at any time during or after the meal. 😊 *Cash payment only possible if you order at the counter.',
  buttons: {
    got_it: 'Got it 👍',
  },
};
